import axios from 'axios';
import Cookie from 'cookies-js';
import alertify from 'alertifyjs';
import config from '../../../config/index';
import routes from '../../../constants/routes';
import {
  WITHDRAW_MT_LIP_INVESTMENT,
  WITHDRAW_MT_LIP_INVESTMENT_ERROR,
  WITHDRAW_MT_LIP_INVESTMENT_LOADING,
  WITHDRAW_MT_LIP_INVESTMENT_ERROR_DELETE
} from '../../types';

const withdrawMtLipInvestmentSuccess = withdrawMtLip => ({
  type: WITHDRAW_MT_LIP_INVESTMENT,
  withdrawMtLip
});

const withdrawMtLipInvestmentLoading = () => ({
  type: WITHDRAW_MT_LIP_INVESTMENT_LOADING
});

const withdrawMtLipInvestmentError = error => ({
  type: WITHDRAW_MT_LIP_INVESTMENT_ERROR,
  error
});

export const deleteWithdrawMtLipInvestmentError = () => ({
  type: WITHDRAW_MT_LIP_INVESTMENT_ERROR_DELETE
});

const withdrawMtLipInvestment = withdrawalDetails => (dispatch) => {
  dispatch(withdrawMtLipInvestmentLoading());
  const token = Cookie.get('jwtToken');
  return axios.post(
    `${config.apiUrl}${routes.WITHDRAWMTLIPINVESTMENT}`, withdrawalDetails, {
      headers: { Authorization: `Bearer ${token}` }
    }
  ).then((response) => {
    const { data } = response;
    if (data.isSuccessful) {
      dispatch(withdrawMtLipInvestmentSuccess(data));
      alertify
        .alert('You have succeeded in withdrawing from your MT-Lip Investment.', () => {
          alertify.success('OK');
        }).setHeader('<em style="color: green; font-size: 18px; font-weight: bold;"> Success!!! </em> ');
      window.location.href = '/invest-plans';
    } else {
      dispatch(withdrawMtLipInvestmentError(data.responseMessage));
    }
  }).catch((error) => {
    const { data } = error.response;
    dispatch(withdrawMtLipInvestmentLoading());
    dispatch(withdrawMtLipInvestmentError(data.responseMessage));
    throw error;
  });
};

export default withdrawMtLipInvestment;
